import React, { useMemo } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { format } from 'date-fns';
import globalUserPage from '../../../../stores/global-user-page';
import { observer } from 'mobx-react-lite';
import { LectureDetailsStudentWithCourseDetails } from '../../../../api/types/students/lectures/student-lectures';

export const UserPageStudentLectures: React.FC = observer(() => {
  const lectures = useMemo(() => {
    return globalUserPage.studentDetails?.lectures ?? [];
  }, [globalUserPage.studentDetails?.lectures]);

  const formatDateTime = (date: Date | undefined) => {
    if (!date) return '';
    return format(new Date(date), 'dd/MM/yyyy');
  };

  const formatTime = (date: Date | undefined) => {
    if (!date) return '';
    return format(new Date(date), 'HH:mm');
  };

  const attendanceStatusTemplate = (
    rowData: LectureDetailsStudentWithCourseDetails,
  ) => {
    if (!rowData.attendanceType)
      return <span style={{ color: '#999' }}>המפגש טרם התקיים</span>;
    return rowData.attendanceType === 'attended'
      ? 'נוכח'
      : rowData.attendanceType === 'late'
        ? 'איחור'
        : 'חיסור';
  };

  return (
    <div style={{ width: '100%', padding: '20px' }}>
      <h2 style={{ marginBottom: '20px' }}>מפגשי השבוע</h2>
      <DataTable
        value={lectures}
        rows={10}
        rowsPerPageOptions={[5, 10, 25, 50]}
        emptyMessage="לא נמצאו מפגשים"
        style={{ direction: 'rtl' }}
      >
        <Column
          field="programName"
          header="תוכנית"
          sortable
          style={{ textAlign: 'right' }}
        />
        <Column
          field="courseName"
          header="קורס"
          sortable
          style={{ textAlign: 'right' }}
        />
        <Column
          body={(rowData) => formatDateTime(rowData.startTime)}
          header="תאריך"
          sortable
          style={{ textAlign: 'right' }}
        />
        <Column
          body={(rowData) => formatTime(rowData.startTime)}
          header="שעת התחלה"
          sortable
          style={{ textAlign: 'right' }}
        />

        <Column
          body={(rowData) => formatTime(rowData.endTime)}
          header="שעת סיום"
          sortable
          style={{ textAlign: 'right' }}
        />
        <Column
          field="buildingName"
          header="מבנה"
          sortable
          style={{ textAlign: 'right' }}
        />
        <Column
          field="className"
          header="כיתה"
          sortable
          style={{ textAlign: 'right' }}
        />
        {/*        <Column
          body={attendanceStatusTemplate}
          header="סטטוס מפגש"
          sortable
          style={{ textAlign: 'right' }}
        />*/}
        <Column
          body={attendanceStatusTemplate}
          header="נוכחות"
          sortable
          style={{ textAlign: 'right' }}
        />
      </DataTable>
    </div>
  );
});
